/* -----------------------------
   Cross-sell arrows (CSS slider)
------------------------------ */
document.addEventListener('click', (e) => {
  const next = e.target.closest('.cross-next');
  const prev = e.target.closest('.cross-prev');
  if (!next && !prev) return;

  const wrapper = e.target.closest('.cart-cross-sell');
  if (!wrapper) return;

  const track = wrapper.querySelector('.cart-cross-sell__track');
  if (!track) return;

  const amount = track.offsetWidth * 0.8;
  track.scrollBy({
    left: next ? amount : -amount,
    behavior: 'smooth',
  });
});


/* -----------------------------
   Add to cart (drawer-safe)
------------------------------ */
document.addEventListener('click', async (e) => {
  const button = e.target.closest('.cart-cross-sell__btn');
  if (!button) return;

  e.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = 'Toevoegen...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });

    // ✅ Ask theme to refresh cart drawer properly
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cross-sell',
      variantId: variantId,
    });

    // ✅ Update count instantly (no flicker)
    updateDrawerCartCount();

    button.textContent = 'Toegevoegd!';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1200);

  } catch (err) {
    console.error(err);
    button.textContent = originalText;
    button.disabled = false;
  }
});

function updateDrawerCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const countEl = document.querySelector('.drawer-cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
      }
    });
}
